import { MessageSquarePlus } from 'lucide-react'
import { Button } from '@duck/ui'
import { useTar } from '@/modules/i18n/useTar'
import { useUserVoice } from '@/hooks/useUserVoice'

export const HomePageVoiceCard = () => {
  const { t } = useTar()
  const { openVoice } = useUserVoice()

  return (
    <section
      aria-labelledby="voice-card-heading"
      className="border-y border-border/50 px-6 py-5 md:px-8 md:py-6"
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
        <MessageSquarePlus aria-hidden className="hidden h-8 w-8 shrink-0 text-accent/70 md:block" />
        <div className="flex-1 space-y-1">
          <h2 id="voice-card-heading" className="text-lg font-semibold text-foreground">
            {t('home.voice.title')}
          </h2>
          <p className="text-muted-foreground">{t('home.voice.subtitle')}</p>
        </div>
        <Button
          variant="outline"
          className="shrink-0 gap-2 self-start md:self-auto"
          onClick={() => openVoice({ source: 'homepage' })}
        >
          <MessageSquarePlus aria-hidden className="h-4 w-4 md:hidden" />
          {t('home.voice.cta')}
        </Button>
      </div>
    </section>
  )
}
